import {
  useQuery,
  UseQueryOptions
} from '@smuchile/pkg-unimarc-hooks/reactQuery'
import {
  fetchBannerSearch,
  FetchBannerSearchParams
} from '../services/fetchBannerSearch'

interface UseBannerSearchParams extends FetchBannerSearchParams {
  enabled?: boolean
  reactQuery?: UseQueryOptions<any, any, any, any>
}

export const useBannerSearch = ({
  type,
  value,
  enabled = true,
  reactQuery
}: UseBannerSearchParams) => {
  return useQuery(
    ['bannerSearch', type, value],
    () => fetchBannerSearch({ type, value }),
    {
      enabled: enabled && !!value,
      ...reactQuery
    }
  )
}
